import React from "react";
import { pageTitle } from "../../helpers/PageTitle";

export default function RefundPolicy() {
  pageTitle("Refund Policy");
  return (
    <div style={{ margin: "80px auto", padding: 24, paddingTop: "80px" }}>
      <style>
        {`
          h1 {
            text-align: center;
          }
          h2 {
            margin-top: 30px;
            margin-bottom: 15px;
            font-size: 25px;
          }
          ul {
            margin-left: 20px;
          }
          .privacy-content {
            margin-top: 80px;
            padding-left: 50px;
            margin: 80px auto;
          }
          .effective-date {
            font-weight: bold;
            font-size: 18px;
          }
          .email-link {
            color: white;
            text-decoration: none;
          }
            @media screen and (max-width: 991px) {
    body, html {
        font-size: 16px;
        line-height: 1.6em;
    }
         h2 {
           font-size: 18px;
          }
           h1 {
    font-size: 29px;
}
    .privacy-content {
    margin-top: 80px;
    padding-left: 0px;
    }

        `}
      </style>
      <h1 style={{ textAlign: "center" }}>Refund & Rescheduling Policy – Ignite Sports Pavilion</h1>
      <div className="privacy-content">
        
        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>Refund Policy</h2>
        <p>
          We understand that plans can change. If you need to cancel your court booking, please carefully follow the procedure below to apply for a refund.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>How to Request a Refund:</h2>
        <p>
          To apply for a refund, please send a WhatsApp message to <a href="tel:03193446438" style={{ color: "white", textDecoration: "none" }}>0319 3446438</a> with the following details:
        </p>
        <ul style={{ marginLeft: "20px" }}>
          <li>Booking Date & Time</li>
          <li>Sport Name</li>
          <li>Court Number</li>
          <li>Full Name under which the booking was made</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>Important Terms:</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>Refund requests will only be accepted if submitted at least 24 hours before the scheduled booking time.</li>
          <li>Refunds will only be issued to the original person who made the booking, after verifying their identity.</li>
          <li>The refund process can take up to 5 working days from the date of confirmation.</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>Refunds Will NOT Be Issued If:</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>The cancellation request is received less than 24 hours before the booking time.</li>
          <li>The booking was missed or a "no-show" occurred without prior notice.</li>
          <li>The booking was cancelled due to bad weather, unless Ignite Sports Pavilion officially declares the ground unplayable.</li>
          <li>The player or group was removed for violating facility rules or misconduct.</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>Rescheduling Policy</h2>
        <p>
          If you wish to reschedule your booking, we're happy to assist—provided there's enough notice and the slot is available.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>Rescheduling Guidelines:</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>You must request a reschedule at least 24 hours prior to your scheduled booking.</li>
          <li>Rescheduling is subject to slot availability and will be handled with mutual understanding.</li>
          <li>To request a reschedule, contact us on WhatsApp at 0319 3446438 with:</li>
        </ul>
        <ul style={{ marginLeft: "40px" }}>
          <li>Booking Date & Time</li>
          <li>Sport Name</li>
          <li>Court Number</li>
          <li>Name under which the booking was made</li>
        </ul>

        <p>
          We aim to keep things fair for all players and ensure smooth scheduling for everyone. For any questions or assistance, feel free to reach out via WhatsApp.
        </p>
        <p style={{ marginTop: "30px", fontStyle: "italic" }}>
          — Team Ignite Sports Pavilion
        </p>
      </div>
    </div>
  );
} 